







import { defineComponent } from 'vue';
import { useSearchExecution } from '../../composables/global_search/useSearchExecution';

export default defineComponent({
  name: 'GlobalSearchHeader',
  setup() {
    const { searchedQuery } = useSearchExecution();
    return {
      searchedQuery,
    };
  },
});
